import { HelpCircle } from "lucide-react";
import {
  AddressAutocomplete,
  AddressComponents
} from "@/components/ui/address-autocomplete";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";

interface EducationLocationFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
}

export function EducationLocationFields({
  profile,
  setProfile,
  readOnly
}: EducationLocationFieldsProps) {
  const { t } = useTranslation("talent");

  const handleEducationAddressChange = (
    addressComponents: AddressComponents
  ) => {
    const isGermany =
      addressComponents.country &&
      (addressComponents.country.toLowerCase().includes("germany") ||
        addressComponents.country.toLowerCase().includes("deutschland") ||
        addressComponents.country.toLowerCase() === "de");

    setProfile({
      ...profile!,
      education_address: addressComponents.formattedAddress,
      education_street: addressComponents.street,
      education_street_number: addressComponents.streetNumber,
      education_postal_code: addressComponents.postalCode,
      education_city: addressComponents.city,
      education_state: addressComponents.state,
      education_country: addressComponents.country,
      recognition_status: isGermany
        ? "approved"
        : profile?.recognition_status || "not_applied"
    });
  };

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        <label className="text-sm font-medium">
          {t("forms.sections.qualifications.fields.education_location.label")}
        </label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <HelpCircle className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {t(
                  "forms.sections.qualifications.fields.education_location.help"
                )}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <AddressAutocomplete
        label=""
        placeholder={t(
          "forms.sections.qualifications.fields.education_location.placeholder"
        )}
        value={profile?.education_address || ""}
        onChange={handleEducationAddressChange}
        disabled={readOnly}
        name="education_address"
      />
    </div>
  );
}
